import { TextField } from "@mui/material";
import { useEffect, useRef } from "react";

import type { TextFieldProps } from "@mui/material";
import type { FC } from "react";

export const TextFieldWithAutoFocus: FC<TextFieldProps> = (params) => {
  const ref = useRef<HTMLInputElement>(null);
  useEffect(() => {
    setTimeout(() => {
      ref.current?.focus();
    }, 100);
  }, []);

  return <TextField {...params} inputRef={ref} />;
};
